import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Building2, FileText, Scale, BookOpen, Mail, Phone, User, Menu, X } from 'lucide-react';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <div className="logo-icon">DG</div>
          <span className="logo-name">DATAGREFFE</span>
        </Link>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/recherche" onClick={() => setMenuOpen(false)}>
            <Building2 size={16} />
            Entreprises
          </Link>
          <Link to="/aide" onClick={() => setMenuOpen(false)}>
            <FileText size={16} />
            Formalité
          </Link>
          <Link to="/aide" onClick={() => setMenuOpen(false)}>
            <Scale size={16} />
            Justice
          </Link>
          <Link to="/textes-de-loi" onClick={() => setMenuOpen(false)}>
            <BookOpen size={16} />
            Textes de loi
          </Link>
        </div>

        <div className="navbar-right">
          <div className="navbar-contact">
            <a href="mailto:contact@datagreffe.ci" className="contact-item">
              <Mail size={14} />
              contact@datagreffe.ci
            </a>
            <a href="tel:+2250718426314" className="contact-item">
              <Phone size={14} />
              07 18 42 63 14
            </a>
          </div>
          <div className="navbar-actions">
            <Link to="/aide" className="btn-services">Nos Services</Link>
            <Link to="/connexion" className="btn-connexion">
              <User size={16} />
              Connexion
            </Link>
          </div>
          <button className="icon-btn mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
